import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FacebookService } from "src/app/services/social/facebook.service";

@Component({
  selector: "app-facebook-post",
  templateUrl: "./facebook-post.component.html",
})
export class FacebookPostComponent implements OnInit {
  post: any = {};

  @ViewChild('videoElement') videoElement: ElementRef;
  constructor(private facebookService: FacebookService) {}

  ngOnInit() {
    this.facebookService.postToView.subscribe((post: object) => {
      if (!Object.keys(post).length) return;

      this.post = post;
      this.openPostModal();
    });
  }

  openPostModal() {
    document.getElementById("facebookPostModalBtn").click();
  }

  onCloseModal() {
    if (this.videoElement && this.videoElement.nativeElement) {
      this.videoElement.nativeElement.pause();
      this.videoElement.nativeElement.currentTime = 0; // Reset video
    }

    this.post = {};
  }
}
